import { render, staticRenderFns } from "./ScrollTableWrapper.vue?vue&type=template&id=7680199e&scoped=true"
import script from "./ScrollTableWrapper.vue?vue&type=script&lang=js"
export * from "./ScrollTableWrapper.vue?vue&type=script&lang=js"
import style0 from "./ScrollTableWrapper.vue?vue&type=style&index=0&id=7680199e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7680199e",
  null
  
)

export default component.exports